import axios from 'axios';
import { API_CONFIG } from "./../config/config.jsx";

export const login = ({ username = '', password = '' }) => {
  return async (dispatch) => {
    axios.post(`${API_CONFIG.HOST}/auth/login`, {
      username,
      password,
    }).then((response) => {
      console.log(response);
      sessionStorage.setItem('plugoAuthKey', response.data.jwtToken);
      sessionStorage.setItem('plugoUserId', response.data.id);
      sessionStorage.setItem('plugoUserMobileNo', response.data.userName);
      sessionStorage.setItem('authoritiesList', response.data.roles);
      dispatch({
        type: 'LOGIN',
        payload: {
          username,
          password,
          token: response.data.jwtToken,
          userId: response.data.id,
          resStatus: true
        }
      })
    }).catch((error) => {
      if (error.response) {
        dispatch({
          type: 'LOGIN',
          payload: {
            username,
            password,
            resStatus: false,
            resMessage: error.response.data.message || 'Invalid credentials'
          }
        });
      } else {
        dispatch({
          type: 'LOGIN',
          payload: {
            username,
            password,
            resStatus: false,
            resMessage: 'Server is unavailable.'
          }
        });
      }
    });
  }
}

export const logout = ({ token = '', userId = '' } = {}) => {
  return async (dispatch) => {
    if (!token) {
      token = await sessionStorage.getItem('plugoAuthKey');
    }
    if (!userId) {
      userId = await sessionStorage.getItem('plugoUserId');
    }
    await sessionStorage.removeItem('plugoAuthKey');
    await sessionStorage.removeItem('plugoUserId');
    await sessionStorage.removeItem('authoritiesList');
    axios.get(`${API_CONFIG.HOST}/users/logout`, {
      headers: {
        "Authorization": `Bearer ${token}`,
      }
    }).then(() => {
      dispatch({
        type: 'LOGOUT'
      })
    }).catch(error => {
      dispatch({
        type: 'LOGOUT'
      })
    })
  }
}

export const resetPassword = ({otp='', password = '' }) => {
  let email=  sessionStorage.getItem('plugoUserMobileNo');
  return async (dispatch) => {
    axios.post(`${API_CONFIG.HOST}/user/reset-password`, {
      otp,
      email,
      password,
    }).then((response) => {
      console.log(response);
      // sessionStorage.setItem('plugoAuthKey', response.data.jwtToken);
      // sessionStorage.setItem('plugoUserId', response.data.id);
      // sessionStorage.setItem('plugoUserMobileNo', response.data.userName);
      // sessionStorage.setItem('authoritiesList', response.data.roles);
      // dispatch({
      //   type: 'LOGIN',
      //   payload: {
      //     username,
      //     password,
      //     token: response.data.jwtToken,
      //     userId: response.data.id,
      //     resStatus: true
      //   }
      // })
    }).catch((error) => {
      if (error.response) {
        // dispatch({
        //   type: 'LOGIN',
        //   payload: {
        //     username,
        //     password,
        //     resStatus: false,
        //     resMessage: error.response.data.message || 'Invalid credentials'
        //   }
        // });
      } else {
        // dispatch({
        //   type: 'LOGIN',
        //   payload: {
        //     username,
        //     password,
        //     resStatus: false,
        //     resMessage: 'Server is unavailable.'
        //   }
        // });
      }
    });
  }
}
